import React from "react";
import CaracterizacaoFuncionarios from "./_/containers/CaracterizacaoFuncionarios";

const Funcionarios = props => <CaracterizacaoFuncionarios {...props} />;

export default Funcionarios;
